/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import {createSelector} from 'reselect';

export const selectShowJobStatusDrawer = ({jobStatus: {open}}) => open;

export const showJobStatusDrawerSelector = createSelector(selectShowJobStatusDrawer,
  (open: boolean): boolean => open
);
